import {REACT_APP_VMS_BASE_URL} from "../utils/urls";
import axios from 'axios'

const uploadVLCVehicles = async (data: any) => {

    const result = await fetch(`${REACT_APP_VMS_BASE_URL}/vehicles`, {
        method: "PATCH",
        cache: 'no-cache',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        referrerPolicy: 'no-referrer',
        body: data,
    });

    // return await axios.patch(`${REACT_APP_VMS_BASE_URL}/vehicles`, data, {
        // headers: {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        // },
    // });

    // return result
};

export default uploadVLCVehicles;
